import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SignupService } from '@app-services/signup/signup.service';
import { TenantConstant } from '@app-constants/tenant.constant';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { NeetLiveClassDialogComponent } from '@app-shared/components/neet-live-class-dialog/neet-live-class-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TestSeriesScheduleComponent } from '@app-shared/components/test-series-schedule/test-series-schedule.component';
import { UserService } from '@app-services/user/user.service';
import { admissionNumberRegex, openDefaultLoginDialog, openSignUpDialog, openTermsAndConditionsDialog, signup, socialMediaClicked } from '@app-core/components/home/home.component';
import { openAdmissionLoginForm } from 'src/app/helpers/methods';
declare var $: any;
@Component({
  selector: 'app-neet',
  templateUrl: './neet.component.html',
  styleUrls: ['./neet.component.css']
})
export class NeetComponent implements OnInit {
  ngAfterViewInit() {
    $('body').addClass('neet');
  }
  ngOnDestroy() {
    $('body').removeClass('neet');
    clearTimeout(this.timeToken);
    this.dialog.closeAll();
  }
  openNeetLiveClassDialog(mod: any = ''): void {
    clearTimeout(this.timeToken);
    this.dialog.closeAll();
    const config: MatDialogConfig = {
      width: '922px',
      height: '584px',
      id: 'neet-live-class',
      panelClass: 'neet-live-class',
      data: { message: 'Terms of Use', mod }
    };
     const dialogRef = this.dialog.open(NeetLiveClassDialogComponent, config);
  }
  timeToken: any;
  searchValue: any = '';
  clickEventTriggered: boolean = true;
  SCPlaceHolder: any = 'Phone Number';
  SCMaxLength: any = 10;
  signup = signup;
  openSignUpDialog = openSignUpDialog;
  openDefaultLoginDialog = openDefaultLoginDialog;
  openAdmissionLoginForm = openAdmissionLoginForm;
  openTermsAndConditionsDialog = openTermsAndConditionsDialog;
  socialMediaClicked = socialMediaClicked;
  @ViewChild('content') public content: any;
  constructor(private dialog: MatDialog,
    public signUpService: SignupService,
    private gaService: GAnalyticsService,
    private fb: FormBuilder,
    public modalservice: NgbModal,
    public userService: UserService) {
      if(this.portal != 'SCORE') {
        this.SCPlaceHolder = 'Admission Number';
        this.SCMaxLength = 13;
      }
     }

  tenant: any = TenantConstant.tenant;
  portal: any = TenantConstant.portal;
  sriChaitanyaStartForm!: FormGroup;
  customSriChaitanyaStartFormValid = true;

  ngOnInit(): void {
    // this.timeToken = setTimeout(() => {
    //   if (this.clickEventTriggered) {
    //     this.openNeetLiveClassDialog('lc')
    //   }
    // }, 10000);
    if(this.portal != 'SCORE') {
      this.sriChaitanyaStartForm = this.fb.group({
        admissionNumber: ['', [Validators.required, Validators.pattern(admissionNumberRegex)]]
      })
    } else {
      this.sriChaitanyaStartForm = this.fb.group({
        admissionNumber: ['', [Validators.required, Validators.pattern(/^[6-9][0-9]{9}$/)]]
      })
    }
    this.openNeetLiveClassDialog('lc')
  }

  doSearch(value: string): void {
    this.searchValue = value;
  }

  clickEvent() {
    //this.clickEventTriggered = false;
  }
  openTestSeriesSchedule() {

    const config: MatDialogConfig = {
      width: '900px',
      panelClass: 'mat-full',
      data: { examName: 'NEET' }
    };
    const dialogRef = this.dialog.open(TestSeriesScheduleComponent, config);
  }

}
